/**
 * Regras de apresentação de imagens de produto na loja — `tenant.theme_json.storeProductDisplay`.
 */

/** @param {unknown} themeJson */
export function normalizeThemeJson(themeJson) {
  let obj = themeJson;
  if (typeof obj === 'string') {
    try {
      obj = JSON.parse(obj);
    } catch {
      return {};
    }
  }
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return {};
  return /** @type {Record<string, unknown>} */ (obj);
}

/** @type {{ sectionPhotoFallback: boolean }} */
export const STORE_PRODUCT_DISPLAY_DEFAULTS = {
  sectionPhotoFallback: false,
};

/**
 * @param {unknown} themeJson
 * @returns {{ sectionPhotoFallback: boolean }}
 */
export function parseStoreProductDisplay(themeJson) {
  const base = normalizeThemeJson(themeJson);
  const raw = base.storeProductDisplay;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return { ...STORE_PRODUCT_DISPLAY_DEFAULTS };
  }
  return {
    sectionPhotoFallback: Boolean(raw.sectionPhotoFallback),
  };
}

/** @param {unknown} themeJson */
export function storeProductDisplayBodyForEditor(themeJson) {
  const { sectionPhotoFallback } = parseStoreProductDisplay(themeJson);
  return { sectionPhotoFallback };
}
